import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { MetricWidgetLineGraphContainer } from "../../../common/widget/line-graph/MetricWidgetLineGraphContainer";
import { useNewsVolumeOverTimeData } from "../../hooks/useNewsVolumeOverTimeData";

import { useTabs } from "./useTabs";

export const NewsVolumeOverTime = () => {
    const { translate } = useTranslate();
    const { selectedDataType, tabs, tabIndex, onSelect } = useTabs();

    const { data, primaryDomain, isMonthly, isLoading, isError } = useNewsVolumeOverTimeData();

    const graphData = useMemo(
        () =>
            data.map(({ domain, series, averageVolume }) => ({
                id: domain,
                name: domain === primaryDomain ? translate("activation.common.your-domain", { domain }) : domain,
                data: series[selectedDataType],
                total: averageVolume[selectedDataType],
            })),
        [data, primaryDomain, selectedDataType, translate],
    );

    const legendHeaders = useMemo(
        () => [
            translate("common.domain"),
            translate("activation.alerts.news.metrics.news-volume-over-time-widget.legend-header.avg-volume"),
        ],
        [translate],
    );

    return (
        <MetricWidgetLineGraphContainer
            automationId="news-volume-over-time-metrics-widget"
            data={graphData}
            isError={isError}
            isLoading={isLoading}
            isMonthly={isMonthly}
            legendHeaders={legendHeaders}
            onTabSelect={onSelect}
            selectedTabIndex={tabIndex}
            tabs={tabs}
            title={translate("activation.alerts.news.metrics.news-volume-over-time-widget.title")}
        />
    );
};
